<template>
  <div @click="toggle" class="ml-steps__item">
    <step :completed="completed" :show="show" @close="toggle">
      <div class="ml-steps-card__title">{{ $t("mylist.widgetNameBoxTitle") }}</div>
      <template v-slot:icon>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="#424142"
        >
          <path d="M9 9.25C10.5188 9.25 11.75 8.01878 11.75 6.5C11.75 4.98122 10.5188 3.75 9 3.75C7.48122 3.75 6.25 4.98122 6.25 6.5C6.25 8.01878 7.48122 9.25 9 9.25ZM4.5 14.25C4.5 12.1789 6.67893 10.75 9 10.75C11.3211 10.75 13.5 12.1789 13.5 14.25V15H4.5V14.25Z"/>
        </svg>
      </template>
      <template v-slot:modal>
        <div class="card-wizard">
          <div class="card-wizard__title">
            <h3 class="header-3">{{ $t("mylist.widgetNameTitle") }}</h3>
            <div class="card-wizard__subtitle">
              {{ $t("mylist.widgetNameSubtitle") }}
            </div>
          </div>
          <form class="card-wizard__container">
            <div class="bb-form-item bb-form-item--left w-100">
              <label for="name" class="bb-form-label">
                {{ $t("mylist.widgetNameLabel") }}
              </label>
              <input
                v-model="name"
                class="bb-form"
                type="text"
                maxlength="256"
                name="name"
                id="name"
                required=""
                :placeholder="$t('mylist.widgetNamePlaceholder')"
                @blur="nameBlur"
              />

              <div class="bb-form-error" v-show="nameHasError">
                {{ $t("generic.field_is_required") }}
              </div>
            </div>
            <!-- <label for="notDecided" class="bb-form-checkbox">
              <input
                class="mt-4"
                v-model="notDecided"
                type="checkbox"
                name="notDecided"
                id="notDecided"
              />
              {{ $t("mylist.widgetChildNameNoNameYet") }}
            </label> -->

            <div class="card-wizard__actions">
              <loading-button v-if="loading"></loading-button>
              <button
                v-else
                class="button button--primary button--block"
                @click.prevent="save"
                :disabled="disabled"
              >
                {{ $t("generic.save") }}
              </button>
            </div>
          </form>
        </div>
      </template>
    </step>
    <alert v-if="showAlertLocal" @retry="retry" :key="key" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Step from "./Step";
import LoadingButton from "../../../components/LoadingButton";
import OwnerListAlert from "./OwnerListAlert";

export default {
  name: "UserNameStep",
  components: {
    Step,
    "loading-button": LoadingButton,
    alert: OwnerListAlert,
  },
  data() {
    return {
      show: false,
      name: "",
      notDecided: false,
      loading: false,
      nameDirty: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "user",
      showAlertKey: "showAlertKey",
      showAlert: "showAlert",
    }),
    nameHasError() {
      if (this.notDecided) {
        return false;
      }
      return this.name === "" && this.nameDirty;
    },
    showAlertLocal() {
      return this.showAlertKey === this.key && this.showAlert;
    },
    key() {
      return "list_name_step";
    },
    completed() {
      return this.user?.name !== "" && this.user?.name != null;
    },
    disabled() {
      if (this.notDecided) {
        return false;
      } else if (this.name !== "") {
        return false;
      }
      return true;
    },
  },
  watch: {
    notDecided(newValue) {
      if (newValue) this.name = ""
    },
    user: {
      handler() {
        if (this.user?.name === 'TBD') {
          this.name = ''
          this.notDecided = true
        }
        else this.name = this.user?.name;
      },
      deep: true,
    },
  },
  methods: {
    nameBlur() {
      this.dirtyName = true;
      if (this.name !== '') this.notDecided = false
    },
    async retry() {
      this.$store.commit("setAlertRetrying", true);
      await this.save();
      this.$store.commit("setAlertRetrying", false);
    },
    toggle() {
      this.show = !this.show;
    },
    async save() {
      this.loading = true;
      const name = this.notDecided ? "TBD" : this.name;
      try {
        await this.$store.dispatch('updateName',name)
      } catch {
        this.loading = false;
        this.show = false;
        this.$alert.error(
          this.$t("mylist.widgetNameError"),
          true,
          this.key
        );
        this.$emit("updated");
        return;
      }
      this.$store.commit("updateUserField", {
        field: "name",
        value: name,
      });
      this.loading = false;
      this.show = false;
      this.$alert.success(
        this.$t("mylist.widgetChildNameSuccess"),
        this.key
      );
      window.mixpanel.track("Onboarding", {
        "Step Name": "Step User Name",
        Skipped: false,
        "Last O Slide": false,
        "On Seq Com": false,
      });
      window.mixpanel.people.increment("Steps Taken");
    },
  },
  mounted() {
    if (this.user?.name === 'TBD') {
      this.name = ''
      this.notDecided = true
    }
    else this.name = this.user?.name;
  },
};
</script>
